/*--------------------------------------
                  HEDAER
 --------------------------------------*/

mobileMenu = {
    init: function () {
        $(".header__nav__menu-btn").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("open--mobile-menu");
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('.header__nav__menu-btn, .mobile-menu--content').length) {
                $("body").removeClass("open--mobile-menu");
            }
        });
    }
};

mobileSubmenus = {
    init: function () {
        $(".mobile-menu__body__item.parent .mobile-menu__body__item__link").on("click", function (e) {
            e.preventDefault();
            var parent = $(this).closest('.parent');

            if (!parent.hasClass("open")) {
                // OPEN
                parent.addClass("open");
                parent.find('.submenu').height(parent.find('.submenu--inner').outerHeight());
            } else {
                // CLOSE
                parent.removeClass("open");
                parent.find('.submenu').height(0);
            }
        });

    }
};

solutionsSubmenu = {
    init: function () {
        $("a[href='#solutions-submenu']").on("click", function (e) {
            e.preventDefault();

            if (!$("body").hasClass("open--solutions-submenu")) {
                // OPEN
                $("body").toggleClass("open--solutions-submenu");
                $(".section-solutions-submenu").height($(".solutions-submenu--content-inner").outerHeight());

            } else {
                // CLOSE
                $("body").removeClass("open--solutions-submenu");
                $(".section-solutions-submenu").height(0);
            }
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('a[href="#solutions-submenu"], .solutions-submenu--content').length) {
                $("body").removeClass("open--solutions-submenu");
                $(".section-solutions-submenu").height(0);
            }
        });
    }
};

userPopup = {
    init: function () {
        $("a[href='#usr-popup']").on("click", function (e) {
            e.preventDefault();

            if (!$("body").hasClass("open--user-popup")) {
                // OPEN
                $("body").toggleClass("open--user-popup");
                $(".section-user-popup").height($(".user-popup--inner").outerHeight());

            } else {
                // CLOSE
                $("body").removeClass("open--user-popup");
                $(".section-user-popup").height(0);
            }
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('a[href="#usr-popup"], .user-popup--content').length) {
                $("body").removeClass("open--user-popup");
                $(".section-user-popup").height(0);
            }
        });
    }
};

loginPopup = {
    init: function () {
        $("a[href='#login-popup']").on("click", function (e) {
            e.preventDefault();

            if (!$("body").hasClass("open--login-popup")) {
                // OPEN
                $("body").toggleClass("open--login-popup");
                $(".section-login-popup").height($(".login-popup--inner").outerHeight());

            } else {
                // CLOSE
                $("body").removeClass("open--login-popup");
                $(".section-login-popup").height(0);
            }
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('a[href="#login-popup"], .login-popup--content').length) {
                $("body").removeClass("open--login-popup");
                $(".section-login-popup").height(0);
            }
        });
    }
};

mobileSearchPopup = {
    init: function () {
        $("a[href='#mobile-search-popup']").on("click", function (e) {
            e.preventDefault();

            if (!$("body").hasClass("open--mobile-search-popup")) {
                // OPEN
                $("body").toggleClass("open--mobile-search-popup");
                $(".header__search").height($(".header__search--inner").outerHeight());
                setTimeout(function () {
                    $('.header__search input[name="q"]').focus();
                }, 350);

            } else {
                // CLOSE
                $("body").removeClass("open--mobile-search-popup");
                $(".header__search").height(0);
            }
        });

        // If on search page, open the mobile search popup on load
        if (window.location.pathname === '/search' && $(window).width() <= 991) {
            $("body").addClass("open--mobile-search-popup");
            $(".header__search").height($(".header__search--inner").outerHeight());
            setTimeout(function () {
                $('.header__search input[name="q"]').focus();
            }, 350);
        }

        $("body").on("click", function (event) {
            if ($(window).width() <= 991 && $("body").hasClass("open--mobile-search-popup")) {
                if (!$(event.target).closest('a[href="#mobile-search-popup"], .header__search').length) {
                    $("body").removeClass("open--mobile-search-popup");
                    $(".header__search").height(0);
                }
            }
        });
    }
};

langMenu = {
    init: function () {
        $(".lang-selector").on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass("open");
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('.lang-selector').length) {
                $(".lang-selector").removeClass("open");
            }
        });
    }
};


/*--------------------------------------
                 CART  
 --------------------------------------*/
cartAcceptance = {
    init: function () {
        if ($('.cart__checkout__acceptance').length > 0) {
            $('.cart__checkout__btn').attr('disabled', 'disabled');
       

            $('.cart__checkout__acceptance input[type="checkbox"]').on('click', function () {
                if ($(this).is(':checked')) {
                    $('.cart__checkout__btn').removeAttr('disabled');
                } else {
                    $('.cart__checkout__btn').attr('disabled', 'disabled');
                }
            });
        }
    }
};


/*--------------------------------------
                 OTHERS 
 --------------------------------------*/
dynamicViewHeight = {
    init: function () {
        function updateViewHeight() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        updateViewHeight();

        window.addEventListener('resize', updateViewHeight);
        window.addEventListener('orientationchange', updateViewHeight);
    }
};

scrollToSSLL = {
    init: function () {
        /** Scroll to a part of the page by classname or by pixel number
        *  -  href="website.com/?scrollto=classname"   ==>  Loads new page and scroll to div with class 'classname'
        *  -  href="scrollto:classname"                ==>  Scrolls to div with class 'classname'
        *  -  href="scrollto:next"                     ==>  Scrolls to next section with class 'block'
        *  -  href="scrollto:0"                        ==>  Scrolls to pixel 0 (top of page)
        *
        * by Lluc  :)
        **/


        /*  --  CLICK LINK  --  */
        $('a[href^="scrollto:"]').on('click', function (e) {
            $("body").removeClass('menu--open');
            e.preventDefault();
            history.pushState(null, null, ' ');

            var btn = $(this);
            var target = $(this).attr('href').split(':')[1];

            scroll(btn, target)
        });


        /*  --  PAGE LOAD  --  */
        var params = getQueryStringParameters(window.location.href);
        if (params['scrollto']) {
            var target = params['scrollto'];
            scroll(null, target);
            removeQueryParam('scrollto', window.location.href);
        }


        /*  --  FUNCTIOMS  --  */

        function scroll(btn, target) {
            if (target == 'next') {
                // Find the next .block element in the document after the current one (regardless of nesting)
                var currentBlock = btn.closest('.block')[0];
                var allBlocks = Array.from(document.querySelectorAll('.block'));
                var curIndex = allBlocks.indexOf(currentBlock);
                var nextSection = (curIndex !== -1 && curIndex < allBlocks.length - 1) ? $(allBlocks[curIndex + 1]) : $();

                if (nextSection.length) {
                    $('html, body').animate({
                        scrollTop: $(nextSection).offset().top
                    }, 800);
                }

            } else if ($('.' + target).length) {
                $('html, body').animate({
                    scrollTop: $('.' + target).offset().top
                }, 800);

            } else if (isNumber(target)) {
                $('html, body').animate({
                    scrollTop: target
                }, 800);
            }
        }

        function isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function getQueryStringParameters(url) {
            var params = {};
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        }

        function removeQueryParam(param, url) {
            var urlObj = new URL(url);
            urlObj.searchParams.delete(param);
            window.history.pushState({}, '', urlObj.href);
        }
    }
};

themeColors = {
    init: function () {

        $('.theme-color-selector').on('click', function () {
            var currentColor = getCookie('themeColor');
            var newColor = (currentColor === 'dark') ? 'light' : 'dark';
            setCookie('themeColor', newColor, 365);

            $("html").removeClass('theme-light theme-dark');
            $("html").addClass('theme-' + newColor);
        });

        function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(";").shift();
            return null;
        }

        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }
};

animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 1.8, { ease: Expo.easeOut, y: 30 }).to(this, 1.2, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            }).setTween(tw).addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var tw = new gsap.timeline();
            tw.to(this, 1.2, { opacity: 1 });

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            }).setTween(tw).addTo(controller);
        });

        //FADEIN UP BIG
        $('[data-fadeinupbig]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 3, { ease: Expo.easeOut, y: 100 }).to(this, 1.5, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            }).setTween(tw).addTo(controller);
        });


        //FADEIN RIGHT
        $('[data-fadeinright]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 3, { ease: Expo.easeOut, x: -120 }).to(this, 1.5, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            }).setTween(tw).addTo(controller);
        });


        //FADEIN LEFT
        $('[data-fadeinleft]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 3, { ease: Expo.easeOut, x: 120 }).to(this, 1.5, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            })
                .setTween(tw).addTo(controller);
        });
    }
};

pageHero = {
    init: function () {
        if ($(".page-hero").length > 0) {
            $("body").addClass("page-hero");
        }
    },
};

pngToSvg = {
    init: function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }
};

$(document).ready(function () {
    // HEADER
    mobileSearchPopup.init();
    solutionsSubmenu.init();
    mobileSubmenus.init();
    mobileMenu.init();
    loginPopup.init();
    userPopup.init();
    langMenu.init();

    // CART
    cartAcceptance.init();

    // OTHERS
    dynamicViewHeight.init();
    scrollToSSLL.init();
    themeColors.init();
    animations.init();
    pageHero.init();
    pngToSvg.init();
});